//const apiUrl = 'http://localhost:5000/';
//const appUrl = 'http://localhost:3000/'
const apiUrl = 'https://back-api.modmotapps.com/';
const appUrl = 'https://modmotapps.com/'

export const constants = { apiUrl, appUrl };